module.exports = __webpack_public_path__ + "img/test-night.487703c9.png";